import { Injectable } from '@angular/core';
import {
  HttpHeaders, HttpClient, HttpInterceptor, HttpRequest,
  HttpResponse, HttpEvent, HttpErrorResponse, HttpHandler
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient) { }

  get(url: string, options?: any): Observable<any> {
    console.log(this.optionsRequest(options))
    return this.http
      .get(this.buildUrl(url), this.optionsRequest(options))
  }

  post(url: string, body: any, options?: any): Observable<any> {
    return this.http
      .post(this.buildUrl(url), body, this.optionsRequest(options))
  }

  put(url: string, body: any, options?: any): Observable<any> {
    return this.http
      .put(this.buildUrl(url), body, this.optionsRequest(options))
  }

  patch(url: string, body: any, options?: any): Observable<any> {
    return this.http
      .patch(this.buildUrl(url), body, this.optionsRequest(options))
  }

  delete(url: string, options?: any): Observable<any> {
    return this.http
      .delete(this.buildUrl(url), this.optionsRequest(options))
  }


  private optionsRequest(options) {
    console.log('entro en optionsRequest');
    console.log(options);
    try{
      return options ?
      options : {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + String(localStorage.getItem('access_token') || null),
        })
      }
    }catch(err){
      return options ?
      options : {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      }
    }
  }

  private buildUrl(url: string) {
    return url.startsWith('http') ? url : environment.apiUrl + url
  }

}
